import { cloudCode } from "@/modules/cloud";

export function linkWebDevice(xmppLogin: string) {
  return cloudCode.run("linkWebDevice", { xmppLogin });
}
export function deleteAccountSendEmail() {
  return cloudCode.run("deleteAccountSendEmail");
}
